import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  subsectionReleaseTitle: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.release.title',
    defaultMessage: 'Release Date and Time',
    description: 'Release data time section title in subsection settings sidebar.',
  },
  releaseDateLabel: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.release.date-label',
    defaultMessage: 'Release Date',
    description: 'Release data time section label in subsection settings sidebar.',
  },
  releaseTimeLabel: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.release.time-label',
    defaultMessage: 'Release Time (UTC)',
    description: 'Release data time section label in subsection settings sidebar.',
  },
  subsectionGradingTitle: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.grading.title',
    defaultMessage: 'Subsection Grading',
    description: 'Subsection Grading section title in subsection settings sidebar',
  },
  subsectionGradingUngradedBtn: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.grading.ungraded-btn',
    defaultMessage: 'Ungraded',
    description: 'Subsection Grading section Ungraded button text in subsection settings sidebar',
  },
  subsectionGradingGradedBtn: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.grading.graded-btn',
    defaultMessage: 'Graded',
    description: 'Subsection Grading section Graded button text in subsection settings sidebar',
  },
  subsectionGradingDropdownLabel: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.grading.dropdown-label',
    defaultMessage: 'Grade as:',
    description: 'Dropdown label for selecting assignment type in subsection settings sidebar',
  },
  subsectionGradingDropdownPlaceholder: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.grading.dropdown-placeholder',
    defaultMessage: 'Select Assignment Type',
    description: 'Dropdown placeholder for selecting assignment type in subsection settings sidebar',
  },
  subsectionGradingDueDateLabel: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.grading.due-date-label',
    defaultMessage: 'Due Date',
    description: 'Label for Due Date field in subsection settings sidebar',
  },
  subsectionGradingDueTimeLabel: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.grading.due-time-label',
    defaultMessage: 'Due Time (UTC)',
    description: 'Label for Due Time field in subsection settings sidebar',
  },
  subsectionVisibilityTitle: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.visibility.title',
    defaultMessage: 'Visibility',
    description: 'Subsection visibility section title in subsection settings sidebar',
  },
  subsectionVisibilityStudentVisible: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.visibility.student-visible',
    defaultMessage: 'Student Visible',
    description: 'Visibility option for student visibility in subsection settings sidebar',
  },
  subsectionVisibilityStaffOnly: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.visibility.staff-only',
    defaultMessage: 'Staff Only',
    description: 'Visibility option for staff only in subsection settings sidebar',
  },
  subsectionVisibilityHideAfterDueLabel: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.visibility.hideAfterDue',
    defaultMessage: 'Hide content after due date',
    description: 'Hide content after due date Checkbox label',
  },
  subsectionAssessmentResultsTitle: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.assessment-results.title',
    defaultMessage: 'Assessment Results Visibility',
    description: 'Subsection Assessment Results Visibility section title in subsection settings sidebar',
  },
  subsectionAssessmentResultsShowBtn: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.assessment-results.show-btn',
    defaultMessage: 'Show',
    description: 'Subsection Assessment Results Visibility section show button text in subsection settings sidebar',
  },
  subsectionAssessmentResultsHideBtn: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.assessment-results.hide-btn',
    defaultMessage: 'Hide',
    description: 'Subsection Assessment Results Visibility section hide button text in subsection settings sidebar',
  },
  subsectionAssessmentResultsCheckbox: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.assessment-results.checkbox',
    defaultMessage: 'Only show results after due date',
    description: 'Subsection Assessment Results Visibility section checkbox text in subsection settings sidebar',
  },
  subsectionSpecialExamTitle: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.special-exam.title',
    defaultMessage: 'Set as Special Exam',
    description: 'Subsection Set as Special Exam section title in subsection settings sidebar',
  },
  accessRestrictionsTitle: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.access-restrictions.title',
    defaultMessage: 'Access Restrictions',
    description: 'Title for the Access Restrictions section in subsection settings sidebar',
  },
  accessRestrictionsContentGroups: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.access-restrictions.content-groups',
    defaultMessage: 'Content Groups',
    description: 'Label for the Content Groups dropdown in access restrictions section',
  },
  accessRestrictionsSelectGroupsLabel: {
    id: 'course-authoring.course-outline.sidebar.library.subsection-settings.access-restrictions.select-groups-label',
    defaultMessage: 'Select one or more groups:',
    description: 'Label for selecting groups in the access restrictions section',
  },
});

export default messages;
